import React, { useEffect, useState } from "react";
import { Box, Typography, IconButton, Divider, Tooltip } from "@mui/material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { FiBriefcase, FiEdit3, FiUser, FiActivity, FiClock, FiCalendar, FiInfo } from "react-icons/fi";
import { FaRegFileAlt } from "react-icons/fa";
import { PiSuitcase } from "react-icons/pi";
import { useTheme } from "../../ThemeContext";
import { useFetchGetallDraftsQuery, useFetchPersonalSettingsQuery } from "../../slice/logdetailSlice";
import Delete from "../../assets/images/tasks/DeleteIcon.png";
import { IoIosArrowBack } from "react-icons/io";
import { CommonDeleteDrafts } from "../../components/common/CommonDelete";
import Loader from "../../components/common/Loader";
import dayjs from "dayjs";


export const SubTabs = ({
  taskid,
  login_user_name,
  login_user_id,
  selectedUser,
  owners,
  login_user_role,
  document_count,
  comment_count,
  logHours,
}) => {
  // const { id, name } = useParams();
  // const isOwner = owners?.some((owner) => owner.user_id === login_user_id);
  // console.log("user_listsss :", selectedUser, login_user_id);
  // console.log("user_listsss :", owner_name, login_user_name);

  return (
    <div className=" ">
      <ul className="nav nav-tabs" id="myTab" role="tablist">
        <li className="nav-item pe-4" role="presentation">
          <button
            className=" active text-rgba-gray R_btn"
            id="Assign-task-tab"
            data-bs-toggle="tab"
            data-bs-target="#Assign-task"
            type="button"
            role="tab"
            aria-controls="Assign-task"
            aria-selected="true"
          >
            Assign Tasks
          </button>
        </li>

        <li className="nav-item pe-4" role="presentation">
          <button
            className=" text-rgba-gray R_btn"
            id="Duplicate-tab"
            data-bs-toggle="tab"
            data-bs-target="#Duplicate"
            type="button"
            role="tab"
            aria-controls="Duplicate"
            aria-selected="false"
          >
            Duplicate
          </button>
        </li>
      </ul>
      
      <div className="tab-content" id="myTabContent">
        <div
          className="tab-pane fade show active"
          id="Assign-task"
          role="tabpanel"
          aria-labelledby="Assign-task-tab"
        >
          <DraftCards type="assign" />
        </div>

        <div
          className="tab-pane fade"
          id="Duplicate"
          role="tabpanel"
          aria-labelledby="Duplicate-tab"
        >
          <DraftCards type="default" />
        </div>
      </div>
    </div>
  );
};

export const DraftCards = ({ onClose, date, refetchList,onRefresh }) => {
  const isDarkMode = useTheme();
  const [open, setOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("assign");
  const [rowId, setRowId] = useState(null);
  const [tableDate, setTableDate] = useState(null);

  const {
    data: draft_datas,
    isLoading,
    refetch,
  } = useFetchGetallDraftsQuery({
    date: date,
  });

  useEffect(() => {
    refetch();
  }, []);

  const assignTaskDrafts =
    draft_datas?.find((d) => d.source === "ASSIGN_TASK")?.drafts || [];

  const duplicateDrafts =
    draft_datas?.find((d) => d.source === "DUPLICATE")?.drafts || [];

  const sortedDuplicateDrafts = [...duplicateDrafts].sort((a, b) => {
    const timeA = a.draft_created_on ? dayjs(a.draft_created_on.replace(" at ", " ")).valueOf() : 0;
    const timeB = b.draft_created_on ? dayjs(b.draft_created_on.replace(" at ", " ")).valueOf() : 0;
    return timeB - timeA;
  });

  const handleDeleteRow = (id, date) => {
    setOpen(true);
    setRowId(id);
    setTableDate(date);
  };
  const handleClose = () => setOpen(false);

  const renderDraftList = (drafts) =>
    drafts.map((item) => {
      const date = item.task_date ? dayjs(item.task_date).format("DD/MM/YYYY") : "";

      const time = item.draft_created_on
        ? (item.draft_created_on.includes(" at ")
            ? item.draft_created_on.split(" at ")[1]?.toLowerCase()
            : dayjs(item.draft_created_on).format("hh:mm a"))
        : "";
      const createdDate = item.draft_created_on
        ? (item.draft_created_on.includes(" at ")
            ? dayjs(item.draft_created_on.split(" at ")[0]).format("DD/MM/YYYY")
            : dayjs(item.draft_created_on).format("DD/MM/YYYY"))
        : "";
      const duplicateFromDate = item.duplicate_from_date
        ? dayjs(item.duplicate_from_date).format("DD/MM/YYYY")
        : createdDate;

      return (
        <div
          key={item?.task_allocation_draft_id}
          className="p-3 mb-3 border"
          style={{
            borderColor: isDarkMode ? "#444" : "#dee2e6",
            backgroundColor: isDarkMode ? "var(--cell-bg-color)" : "#ffffff",
            borderRadius: "6px",
          }}
        >

          <div className="d-flex align-items-center justify-content-between gap-2 mb-3">
            <div className="d-flex align-items-center gap-2">
              <div
                className="d-flex align-items-center justify-content-center rounded"
                style={{
                  width: "36px",
                  height: "36px",
                  backgroundColor: item?.source === "ASSIGN_TASK" ? "rgba(25, 118, 210, 0.1)" : "rgba(16, 185, 129, 0.1)",
                  color: item?.source === "ASSIGN_TASK" ? "#1976d2" : "#10b981",
                }}
              >
                <FiCalendar size={18}/>
              </div>

              <h5 className="mb-0 fw-normal" style={{ color: "var(--task-text)", fontWeight: "normal" }}>
                {date}
              </h5>
            </div>
            
            <Tooltip title="Delete" className="cursor-pointer">
              <IconButton
                onClick={() =>
                  handleDeleteRow(item?.task_allocation_draft_id, date)
                }
                sx={{
                  padding: "10px",
                  borderRadius: "50%",
                  border: "1px solid #e2e8f0",
                  transition: "all 0.2s ease-in-out",
                  "&:hover": {
                    backgroundColor: isDarkMode ? "rgba(255, 0, 0, 0.1)" : "#ffebee",
                    borderColor: isDarkMode ? "rgba(255, 0, 0, 0.1)" : "#ffebee",
                  },
                }}
              >
                <img src={Delete} alt="Delete" height={18} width={18} />
              </IconButton>
            </Tooltip>
          </div>

          <div className="d-flex flex-column gap-2" style={{ paddingLeft: "20px" }}>
            <div className="d-flex align-items-center mb-1" style={{ fontSize: "13px" }}>
              <FiUser size={15} color="var(--text-color)" className="me-2 flex-shrink-0" />
              <span className="text-secondary" style={{ width: "150px", minWidth: "150px" }}>Created By :</span>
              <span style={{ color: "var(--task-text)" }}>{item?.added_by_name}</span>
            </div>

            <div className="d-flex align-items-center mb-1" style={{ fontSize: "13px" }}>
              <FiClock size={15} color="var(--text-color)" className="me-2 flex-shrink-0" />
              <span className="text-secondary" style={{ width: "150px", minWidth: "150px" }}>Created At :</span>
              <span style={{ color: "var(--task-text)" }}>{time}</span>
            </div>

            <div className="d-flex align-items-center mb-1" style={{ fontSize: "13px" }}>
              <FiCalendar size={15} color="var(--text-color)" className="me-2 flex-shrink-0" />
              <span className="text-secondary" style={{ width: "150px", minWidth: "150px" }}>
                {item?.source === "ASSIGN_TASK" ? "Assign date :" : "Duplicated date :"}
              </span>
              <span style={{ color: "var(--task-text)" }}>{date}</span>
            </div>

            {item?.source !== "ASSIGN_TASK" && (
              <div className="d-flex align-items-center mb-1" style={{ fontSize: "13px" }}>
                <FiCalendar size={15} color="var(--text-color)" className="me-2 flex-shrink-0" />
                <span className="text-secondary" style={{ width: "150px", minWidth: "150px" }}>Duplicated task from :</span>
                <span style={{ color: "var(--task-text)" }}>{duplicateFromDate}</span>
              </div>
            )}

            <div className="d-flex align-items-start gap-2 text-rgba-gray small mt-2">
              <FiInfo size={15} color="var(--text-color)" className="mt-1 flex-shrink-0" />
              <span>
                {item?.source === "ASSIGN_TASK" ? (
                  <>
                    This task has been created by <strong>{item?.added_by_name}</strong> on <strong>{createdDate}</strong> at <strong>{time}</strong>
                  </>
                ) : (
                  <>
                    This task has been created by <strong>{item?.added_by_name}</strong> from <strong>{duplicateFromDate}</strong> to duplicate <strong>{date}</strong>
                  </>
                )}
              </span>
            </div>
          </div>
        </div>
      );
    });

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between mb-3">
        <div
          style={{ cursor: "pointer" }}
          onClick={onClose}
          className="d-flex text-rgba-gray align-items-center cursor-pointer"
        >
          <IoIosArrowBack />
          <span className="ms-2">Drafts</span>
        </div>
        {/* <Button variant="outlined" onClick={handleDeleteRow}>
          <img src={Delete} alt="Delete" height={18} width={18} />
        </Button> */}
      </div>

      {/* Tabs */}
      <ul className="nav nav-tabs mb-3">
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "assign" ? "active" : ""}`}
            onClick={() => setActiveTab("assign")}
          >
            Assign Tasks
          </button>
        </li>

        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "duplicate" ? "active" : ""}`}
            onClick={() => setActiveTab("duplicate")}
          >
            Duplicate
          </button>
        </li>
      </ul>

      {/* Content */}
      {isLoading ? (
        <Loader />
      ) : (
        <div>
          {activeTab === "assign"
            ? renderDraftList(assignTaskDrafts)
            // : renderDraftList(duplicateDrafts)}
            : renderDraftList(sortedDuplicateDrafts)}
        </div>
      )}

      {/* Delete Dialog */}
      <CommonDeleteDrafts
        open={open}
        refetchList={refetch}
        refetchlistTwo={refetchList}
        // tableRefetch={refetchList}
        handleClose={handleClose}
        date={tableDate}
        task_allocation_draft_id={rowId}
        calendar_date={date}
        onRefresh={onRefresh}
      />
    </div>
  );
};

const StaffInfoCard = ({ onClose, staff, isDasboard, tableRows }) => {
  // console.log("Staff_is", staff);
  const isDarkMode = useTheme();
  const { data: personal_details } = useFetchPersonalSettingsQuery();
  const {
    updated_by,
    updated_at,
    added_at: created_at,
    added_by: created_by,
    user,
    project,
  } = staff;
  const project_title = project?.title;
  // console.log("task_today :", tableRows);

  return (
    <Box
      sx={{
        width: "100%",
        padding: 2,
        bgcolor: "var(--cell-bg-color)",
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center">
        {/* <Typography sx={{ fontWeight: 600, fontSize: "17px", color: "#333" }}>
          {isDasboard ? project_title : staff?.user_name} */}
        <Typography sx={{ fontWeight: 600, fontSize: "17px", color: isDarkMode ? "var(--task-text)" : "#333" }}>
          {isDasboard ? project_title ? project_title : (staff?.name || staff?.user_name) : "Allocation Details"}
        </Typography>
        <IconButton size="small" onClick={onClose}>
          <HighlightOffIcon sx={{ color: "var(--close-button-color)" }} />
        </IconButton>
      </Box>

      <Divider sx={{ my: 2, borderColor: isDarkMode ? "#666666" : "#cccccc", borderBottomWidth: 1 }} />

      {/* Staff Information */}
      <Box sx={{ mb: 2 }}>
        <Typography sx={{ fontWeight: 600, fontSize: "14px", color: isDarkMode ? "var(--task-text)" : "#333", mb: 1.5, display: "flex", alignItems: "center", gap: 0.5 }}>
          <FiUser size={15} color="var(--text-color)" />
          Staff Information
        </Typography>
        <Box display="flex" justifyContent="space-between" mb={1.5}>
          <Typography fontSize={13} color="var(--text-color)" sx={{ width: "40%" }}>Name</Typography>
          <Typography fontSize={13} fontWeight={500} color={isDarkMode ? "var(--task-text)" : "#333"} sx={{ width: "60%", textAlign: "left" }}>{staff?.name || staff?.user_name || "-"}</Typography>
        </Box>
        <Box display="flex" justifyContent="space-between" mb={1.5}>
          <Typography fontSize={13} color="var(--text-color)" sx={{ width: "40%" }}>Department</Typography>
          <Typography fontSize={13} fontWeight={500} color={isDarkMode ? "var(--task-text)" : "#333"} sx={{ width: "60%", textAlign: "left" }}>{staff?.department_name || staff?.department || "-"}</Typography>
        </Box>
        <Box display="flex" justifyContent="space-between" mb={1.5}>
          <Typography fontSize={13} color="var(--text-color)" sx={{ width: "40%" }}>Designation</Typography>
          <Typography fontSize={13} fontWeight={500} color={isDarkMode ? "var(--task-text)" : "#333"} sx={{ width: "60%", textAlign: "left" }}>{staff?.designation_name || staff?.designation || personal_details?.designation || "-"}</Typography>
        </Box>
      </Box>

      <Divider sx={{ my: 2, borderColor: isDarkMode ? "#666666" : "#cccccc", borderBottomWidth: 1 }} />

      {/* Allocation Information */}
      <Box sx={{ mb: 2 }}>
        <Typography sx={{ fontWeight: 600, fontSize: "14px", color: isDarkMode ? "var(--task-text)" : "#333", mb: 1.5, display: "flex", alignItems: "center", gap: 0.5 }}>
          <FiBriefcase size={15} color="var(--text-color)" />
          Project Information
        </Typography>
        <Box display="flex" justifyContent="space-between" mb={1.5}>
          <Typography fontSize={13} color="var(--text-color)" sx={{ width: "40%" }}>Project</Typography>
          <Typography fontSize={13} fontWeight={500} color={isDarkMode ? "var(--task-text)" : "#333"} sx={{ width: "60%", textAlign: "left" }}>{staff?.project?.title || staff?.project_title || "-"}</Typography>
        </Box>
        <Box display="flex" justifyContent="space-between" mb={1.5}>
          <Typography fontSize={13} color="var(--text-color)" sx={{ width: "40%" }}>Manager</Typography>
          <Typography fontSize={13} fontWeight={500} color={isDarkMode ? "var(--task-text)" : "#333"} sx={{ width: "60%", textAlign: "left" }}>{staff?.project_manager?.name || (typeof staff?.project_manager === "string" ? staff?.project_manager : "-")}</Typography>
        </Box>
        <Box display="flex" justifyContent="space-between" mb={1.5}>
          <Typography fontSize={13} color="var(--text-color)" sx={{ width: "40%" }}>Work Status</Typography>
          <Typography fontSize={13} fontWeight={600} sx={{ width: "60%", textAlign: "left", color: (() => {
            switch (staff?.work_status) {
              case "BENCH": return "#a31616";
              case "ENGAGED": return "#0c5460";
              case "SHORTLY_AVAILABLE": return "#6f42c1";
              case "LONG_TERM":
              case "LONG-TERM": return "#4b7902";
              default: return "inherit";
            }
          })() }}>
            {staff?.work_status || "-"}
          </Typography>
        </Box>
      </Box>

      <Divider sx={{ my: 2, borderColor: isDarkMode ? "#666666" : "#cccccc", borderBottomWidth: 1 }} />

        <Typography sx={{ fontWeight: 600, fontSize: "14px", color: isDarkMode ? "var(--task-text)" : "#333", mb: 1.5, display: "flex", alignItems: "center", gap: 0.5 }}>
        <FiActivity size={15} color="var(--text-color)" />
        Tracking Details
      </Typography>

      {/* <----------------------------------------1 st row-----------------------------------------------> */}

      <Box mb={1} sx={{ width: "100%" }}>
        <Box
          mb={1}
          sx={{
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {/* <----------------------------------------updated  by-----------------------------------------------> */}

          <Box
            sx={{
              width: "40%",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                gap: 0.5,
                alignItems: "center",
              }}
            >
              <FiEdit3 size={13} color="var(--text-color)" />
              <Typography fontSize={13} color="var(--text-color)">
                Last Update By
              </Typography>
            </Box>
            <Box>
              <Typography
                fontSize={13}
                fontWeight={500}
                color={isDarkMode ? "var(--task-text)" : "#333"}
                sx={{ marginLeft: "18px", textAlign: "left" }}
              >
                {staff?.updated_by}
              </Typography>
            </Box>
          </Box>
          {/* <----------------------------------------updated  At-----------------------------------------------> */}

          <Box
            sx={{
              width: "40%",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                gap: 0.5,
                alignItems: "center",
              }}
            >
              <FiEdit3 size={13} color="var(--text-color)" />
              <Typography fontSize={13} color="var(--text-color)">
                Last Update At
              </Typography>
            </Box>
            <Box>

              <Typography
                fontSize={13}
                fontWeight={500}
                color={isDarkMode ? "var(--task-text)" : "#333"}
                sx={{ marginLeft: "20px", textAlign: "left" }}
              >
                {staff?.updated_at}
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* <----------------------------------------2nd row-----------------------------------------------> */}
        <Box
          display="flex"
          justifyContent="space-between"
          sx={{ width: "100%" }}
          mb={1}
        >
          {/* <----------------------------------------created by-----------------------------------------------> */}

          <Box
            sx={{
              width: "40%",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                gap: 0.5,
                alignItems: "center",
              }}
            >
              <FaRegFileAlt size={13} color="var(--text-color)" />
              <Typography fontSize={13} color="var(--text-color)">
                Created By
              </Typography>
            </Box>

            <Typography
              fontSize={13}
              fontWeight={500}
              color={isDarkMode ? "var(--task-text)" : "#333"}
              sx={{ marginLeft: "18px", textAlign: "left" }}
            >
              {staff?.added_by}
            </Typography>
          </Box>

          {/* <----------------------------------------created at-----------------------------------------------> */}

          <Box
            sx={{
              width: "40%",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                gap: 0.5,
                alignItems: "center",
              }}
            >
              <FaRegFileAlt size={13} color="var(--text-color)" />
              <Typography fontSize={13} color="var(--text-color)">
                Created At
              </Typography>
            </Box>

            <Typography
              fontSize={13}
              fontWeight={500}
              color={isDarkMode ? "var(--task-text)" : "#333"}
              sx={{ marginLeft: "18px", textAlign: "left" }}
            >
              {staff?.added_at}
            </Typography>
        </Box>
      </Box>
      </Box>
      
      {isDasboard && (
        <div>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 600, textTransform: "capitalize", mb: 2 }}
          >
            Personal Details
          </Typography>

          <Box sx={{ mb: 2 }}>
            <Typography
              sx={{
                display: "flex",
                alignItems: "center",
                color: "#7c7c7c",
                fontSize: 13,
                mb: 0.5,
              }}
            >
              <FiBriefcase style={{ marginRight: 6 }} /> Experience
            </Typography>
            <Typography sx={{ fontWeight: 500, fontSize: 14 }}>
              {staff?.relevant_experience || "-"}
            </Typography>
          </Box>
        </div>
      )}

      <Divider sx={{ my: 2, borderColor: isDarkMode ? "#666666" : "#cccccc", borderBottomWidth: 1 }} />
      <Box>
        <Typography
          fontSize={13}
          color="var(--text-color)"
          display="flex"
          alignItems="center"
          gap={0.5}
          mb={1}
        >
          <PiSuitcase size={14} color="var(--text-color)" />
          Areas of expertise
        </Typography>

        <Typography
          fontSize={13}
          fontWeight={500}
          color={isDarkMode ? "var(--task-text)" : "#333"}
          sx={{
            wordWrap: "break-word",
            lineHeight: 1.6,
            marginLeft: "18px",
          }}
        >
          {staff?.area_of_expertise
            ?.map((skill) => skill.skill_name) // Extract skill_name
            .join(", ")}
        </Typography>
      </Box>
    </Box>
  );
};

export default StaffInfoCard;
